'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import 'angular-socket-io';

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import 'angular-validation-match';

require('jquery-autocomplete/jquery.autocomplete.css')
require('jquery-autocomplete');

import {
  routeConfig
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import main from './main/main.component';
import order from './order/order.component';
import orderNew from './order/orderNew.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import socket from '../components/socket/socket.service';
import Modal from '../components/modal/modal.service';

import fileInput from './directives/file-input/file-input.directive';
import datePicker from './directives/datePicker/datePicker.directive';
import repeatEndWatch from './directives/repeatEndWatch/repeatEndWatch.directive';
import resultControls from './directives/resultControls/resultControls.directive';
import pagination from './directives/pagination/pagination.directive';
import autoComplete from './directives/autoComplete/autoComplete.directive';
import autoCompleteJobClass from './directives/autoCompleteJobClass/autoCompleteJobClass.directive';
import autoCompleteCompanyGl from './directives/autoCompleteCompanyGl/autoCompleteCompanyGl.directive';
import autoCompleteAccountingUnit from './directives/autoCompleteAccountingUnit/autoCompleteAccountingUnit.directive';
import autoCompleteLocationCode from './directives/autoCompleteLocationCode/autoCompleteLocationCode.directive'; 

import './app.scss';

angular.module('wftOrderFormApp', [ngCookies, ngResource, ngSanitize, 'btford.socket-io', uiRouter,
  uiBootstrap, _Auth, account, admin, 'validation.match', navbar, footer, main, order, orderNew, Modal, constants,
  socket, util, fileInput, datePicker, repeatEndWatch, resultControls, pagination,
  autoComplete, 
  autoCompleteJobClass, autoCompleteCompanyGl, autoCompleteAccountingUnit, autoCompleteLocationCode
])
  .config(routeConfig)
  .run(function($rootScope, $location, Auth, Util) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in

    $rootScope.$on('$stateChangeStart', function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if(next.authenticate && !loggedIn) {
          $location.path('/login');
        }
      });
    });
    $rootScope.$on('$stateChangeSuccess', function() {
      Util.scrollToTop();
    });
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['wftOrderFormApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js